export const destinationOptions = [
  {
    label: "Antigua and Barbuda",
    options: [
      { label: "Antigua and Barbuda", value: "antigua-and-barbuda" }
    ]
  },
  {
    label: "Bahamas",
    options: [
      { label: "All Bahamas", value: "all-bahamas" },
      { label: "March Harbour", value: "march-harbour" },
      { label: "Nassau", value: "nassau" }
    ]
  },
  {
    label: "Belize",
    options: [
      { label: "All Belize", value: "all-belize" }
    ]
  },
  {
    label: 'British Virgin Islands',
    options: [
      { label: "All British Virgin Islands", value: "all-bvi" }
    ]
  },
  {
    label: "Croatia",
    options: [
      { label: "All Croatia", value: "all-croatia" },
      { label: "Agana", value: "agana" },
      { label: "Dubrovnik", value: "dubrovnik" },
      { label: "Split", value: "split" }
    ]
  },
  {
    label: "French Polynesia",
    options: [
      { label: "All French Polynesia", value: "all-french-polynesia" }
    ]
  },
  {
    label: "Greece",
    options: [
      { label: "All Greece", value: "all-greece" },
      { label: "Athens", value: "athens" },
      { label: "Corfu", value: "corfu" },
      { label: "Lefkada", value: "lefkada" }
    ]
  },
  {
    label: "Grenada",
    options: [
      { label: "All Grenada", value: "all-grenada" }
    ]
  },
  {
    label: "Italy",
    options: [
      { label: "All Italy", value: "all-italy" },
      { label: "Cagliari", value: "cagliari" },
      { label: "Cannigione", value: "cannigione" },
      { label: "Furnari", value: "furnari" },
      { label: "Portisco", value: "portisco" },
      { label: "Procida", value: "procida" }
    ]
  },
  {
    label: "Martinique",
    options: [
      { label: "All Martinique", value: "all-martinique" }
    ]
  },
  {
    label: "Seychelles",
    options: [
      { label: "All Seychelles", value: "all-seychelles" }
    ]
  },
  {
    label: "St. Lucia",
    options: [
      { label: "All St. Lucia", value: "all-st-lucia" }
    ]
  },
  {
    label: "St. Martin",
    options: [
      { label: "All St. Martin", value: "all-st-martin" }
    ]
  },
  {
    label: "Thailand",
    options: [
      { label: "All Thailand", value: "all-thailand" }
    ]
  }
];

export const guestOptions = [
  ...Array.from({ length: 11 }, (_, i) => ({
    label: `${i + 1} Guest${i === 0 ? '' : 's'}`,
    value: String(i + 1)
  })),
  { label: '12+ Guests', value: '12+' }
];

export const yachtTypeOptions = [
  'Sailing Yachts',
  'Gulet Yachts',
  'Classic Yachts',
  'Catamarans',
  'Open Yachts',
  'Motor Yachts'
];

export const months = [
  { label: 'May 2025', value: '2025-05' },
  { label: 'June 2025', value: '2025-06' },
  { label: 'July 2025', value: '2025-07' },
  { label: 'August 2025', value: '2025-08' },
  { label: 'September 2025', value: '2025-09' },
  { label: 'October 2025', value: '2025-10' },
  { label: 'November 2025', value: '2025-11' },
  { label: 'December 2025', value: '2025-12' },
  { label: 'January 2026', value: '2026-01' },
  { label: 'February 2026', value: '2026-02' },
  { label: 'March 2026', value: '2026-03' },
  { label: 'April 2026', value: '2026-04' },
  { label: 'May 2026', value: '2026-05' },
  { label: 'June 2026', value: '2026-06' },

];

export const berthOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
];

export const cabinOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
];

export const equipmentOptions = [
  { label: 'Air condition', value: 'air-condition' },
  { label: 'Autopilot', value: 'autopilot' },
  { label: 'Barbecue grill in cockpit', value: 'barbecue-grill' },
  { label: 'Bimini', value: 'bimini' },
  { label: 'Bow thruster', value: 'bow-thruster' },
  { label: 'Chart plotter', value: 'chart-plotter' },
  { label: 'Chart plotter in cockpit', value: 'chart-plotter-cockpit' },
  { label: 'Cockpit cushions', value: 'cockpit-cushions' },
  { label: 'Cockpit speakers', value: 'cockpit-speakers' },
  { label: 'Coffee maker', value: 'coffee-maker' },
  { label: 'DVD player', value: 'dvd-player' },
  { label: 'Dinghy', value: 'dinghy' },
  { label: 'Diving equipment', value: 'diving-equipment' },
  { label: 'Electric toilet', value: 'electric-toilet' },
  { label: 'Electric winches', value: 'electric-winches' },
  { label: 'Flybridge', value: 'flybridge' },
  { label: 'Game console', value: 'game-console' },
  { label: 'Generator', value: 'generator' },
  { label: 'Gennaker', value: 'gennaker' },
  { label: 'Heating', value: 'heating' },
  { label: 'Holding tank', value: 'holding-tank' },
  { label: 'Hydraulic gangway', value: 'hydraulic-gangway' },
  { label: 'Ice maker', value: 'ice-maker' },
  { label: 'Inverter', value: 'inverter' },
  { label: 'Lazy bag', value: 'lazy-bag' },
  { label: 'Lazy jack', value: 'lazy-jack' },
  { label: 'Outboard engine', value: 'outboard-engine' },
  { label: 'Outside Steering Position', value: 'outside-steering' },
  { label: 'Racing sails', value: 'racing-sails' },
  { label: 'Radar', value: 'radar' },
  { label: 'Radio-CD player', value: 'radio-cd' },
  { label: 'Railing net', value: 'railing-net' },
  { label: 'Refrigerator', value: 'refrigerator' },
  { label: 'Snorkeling equipment', value: 'snorkeling-equipment' },
  { label: 'Solar Panels', value: 'solar-panels' },
  { label: 'Spinnaker', value: 'spinnaker' },
  { label: 'Sprayhood', value: 'sprayhood' },
  { label: 'Stand up paddle', value: 'sup' },
  { label: 'Swimming platform', value: 'swimming-platform' },
  { label: 'TV', value: 'tv' },
  { label: 'Teak Cockpit', value: 'teak-cockpit' },
  { label: 'Teak deck', value: 'teak-deck' },
  { label: 'Water maker', value: 'water-maker' },
  { label: 'Wi-Fi & Internet', value: 'wifi' }
];

export const durationOptions = [
  { label: 'Day Charter ', value: 1 },
  { label: '7 Days', value: 7 },
  { label: '10 Days', value: 10 },
  { label: '14 Days', value: 14 }
];

export const inputData = {
  destinationOptions,
  guestOptions,
  yachtTypeOptions,
  months,
  berthOptions,
  durationOptions
};
